<template>
  <OmtLayoutContainer class="hub-teleconsultas">
    <OmtRow :display="['none', 'flex']">
      <HubBreadcrumb :items="breadcrumb" />
    </OmtRow>
    <OmtRow
      stack
      class="hub-teleconsultas__intro"
    >
      <OmtTypography
        as="h1-bold"
        class="hub-teleconsultas__title"
        >Teleconsultas</OmtTypography
      >
      <OmtTypography
        as="p1"
        class="hub-teleconsultas__subtitle"
        color="var(--colors-light-primary-gray1)"
      >
        Participe dos programas dedicados a você. Veja os detalhes e faça a adesão clicando nos cards:
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="16px">
      <div class="hub-teleconsultas__grid">
        <HubOptionCard
          v-for="item in items"
          :key="item.id"
          variant="banner"
          :title="item.title"
          :description="item.description"
          :image="item.image"
          :image-mobile="item.imageMobile"
          :icon="item.icon"
          :badge="item.badge"
          @click="goTo(item.route)"
        />
      </div>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import HubBreadcrumb from "@/components/Organisms/HubSaude/HubBreadcrumb.vue";
import HubOptionCard from "@/components/Organisms/HubSaude/HubOptionCard.vue";
import { hubTeleconsultas } from "@/data/hubSaude";

export default {
  name: "HubSaudeTeleconsultas",
  components: { HubBreadcrumb, HubOptionCard },
  data() {
    return {
      items: hubTeleconsultas,
      breadcrumb: [
        { label: "Home", to: "/" },
        { label: "Hub de saúde", to: "/hub-de-saude" },
        { label: "Teleconsultas" }
      ]
    };
  },
  methods: {
    goTo(route) {
      if (route) this.$router.push(route);
    }
  }
};
</script>

<style scoped>
.hub-teleconsultas {
  width: 100%;
}

.hub-teleconsultas__title {
  color: var(--colors-light-primary-navy-blue);
  margin: 0;
}

.hub-teleconsultas__subtitle {
  margin: 8px 0 0;
}

.hub-teleconsultas__grid {
  display: grid;
  gap: 16px;
  width: 100%;
  align-items: stretch;
}

@media screen and (min-width: 1024px) {
  .hub-teleconsultas__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
